<template>
  <div>
    <router-view></router-view>
      <portal-target name="modals" multiple >
  <!--
      This component can be located anywhere in your App.
      The slot content of the above portal component will be rendered here.
      -->
      </portal-target>
    <SocialChat id="social-button" icon :attendants="attendants" v-if="!isPublicFormRoute">
      <p slot="header">Tim Hebat Waajo siap bantu jawab pertanyaan kamu.</p>
      <template v-slot:button>
        <span class="waajo-help-button-content">
          <img class="waajo-help-button-icon"
            src="https://raw.githubusercontent.com/ktquez/vue-social-chat/master/src/icons/whatsapp.svg"
            alt="icon whatsapp" aria-hidden="true">
          <span class="waajo-help-button-label">Butuh bantuan?</span>
        </span>
      </template>
      <small slot="footer">Senin-Jumat: 8am - 4pm
        <br />Sabtu: 8am - 2pm</small>
    </SocialChat>
  </div>
</template>
<script>
import { SocialChat } from 'vue-social-chat'

export default {
  name: "App",
  components: {
    SocialChat
  },
  created() {
    DataTableEventBus.$on("editData", data =>
      console.log("editing " + data.id)
    );
    DataTableEventBus.$on("viewData", data =>
      console.log("showing " + data.id)
    );
    DataTableEventBus.$on("deleteData", data =>
      console.log("deleting " + data.id)
    );
  },

  computed: {
    isPublicFormRoute() {
      const path = this.$route && this.$route.path ? this.$route.path : "";
      return path === "/form" || path.indexOf("/form/") === 0;
    },
    users() {
      return this.$store.state.users;
    },

    parameters() {
      return {
        data: this.users,
        actionColumn: true,
        columns: this.keys.map(key => ({ key }))
      };
    }
  },

  data() {
    return {
      attendants: [
        // {
        //   app: 'whatsapp',
        //   label: 'Customer Support',
        //   name: 'Wita',
        //   number: '628561500101',
        //   avatar: {
        //     src: 'https://apps.waajo.id/static/assetswaajo/logo.png',
        //     alt: 'WITA'
        //   }
        // },
        {
          app: 'whatsapp',
          label: 'Customer Support',
          name: '',
          number: process.env.VUE_APP_CONTACT_WAAJO,
          avatar: {
            src: 'https://apps.waajo.id/static/assetswaajo/logo.png',
            alt: 'Sekar'
          }
        },
        // ...
      ],
      keys: ["name", "email", "gender", "country", "job", "city", "created_at"]
    };
  }
};
</script>
<style scoped>
:root #social-button {
  --vsc-bg-header: #FF9B44;
  --vsc-bg-footer: #fafafa;
  --vsc-text-color-header: white;
  --vsc-text-color-footer: inherit;
  --vsc-bg-button: #FF9B44;
  --vsc-text-color-button: white;
  --vsc-outline-color: #333;
  --vsc-border-color-bottom-header: transparent;
  --vsc-border-color-top-footer: #f3f3f3;
}
</style>
<style>
#social-button .vsc-popup {
  right: 0 !important;
  bottom: 24px !important;
  max-width: min(380px, calc(100vw - 16px));
  transition: all 0.3s ease;
}

#social-button .vsc-popup-button {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 46px !important;
  height: 46px !important;
  padding: 0 !important;
  overflow: hidden;
  color: #ffffff !important;
  background-color: #f39c12 !important;
  border-radius: 23px 0 0 23px !important;
  box-shadow: -2px 4px 14px rgba(15, 23, 42, 0.18) !important;
  transform: translateX(14px);
  transform-origin: right center;
  transition: all 0.3s ease !important;
}

#social-button .vsc-popup-button:hover,
#social-button .vsc-popup-button:focus {
  width: 178px !important;
  transform: translateX(0);
  background-color: #e08c08 !important;
  box-shadow: -4px 6px 20px rgba(15, 23, 42, 0.24) !important;
}

#social-button .vsc-popup-button[aria-expanded="true"] {
  width: 128px !important;
  justify-content: flex-start;
  padding: 0 14px !important;
  transform: translateX(0);
  background-color: #e08c08 !important;
  box-shadow: -4px 6px 20px rgba(15, 23, 42, 0.24) !important;
}

#social-button .vsc-popup-button[aria-expanded="true"]::after {
  content: "Tutup";
  margin-left: 8px;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
}

#social-button .vsc-popup-button > img {
  flex: 0 0 20px;
  width: 20px !important;
  height: 20px !important;
  object-fit: contain;
}

.waajo-help-button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: all 0.3s ease;
}

#social-button .vsc-popup-button:hover .waajo-help-button-content,
#social-button .vsc-popup-button:focus .waajo-help-button-content {
  justify-content: flex-start;
  padding-left: 13px;
}

.waajo-help-button-icon {
  flex: 0 0 22px;
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.waajo-help-button-label {
  width: 0;
  margin-left: 0;
  overflow: hidden;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  opacity: 0;
  white-space: nowrap;
  transition: all 0.3s ease;
}

#social-button .vsc-popup-button:hover .waajo-help-button-label,
#social-button .vsc-popup-button:focus .waajo-help-button-label {
  width: 112px;
  margin-left: 7px;
  opacity: 1;
}

@media (max-width: 767px) {
  #social-button .vsc-popup {
    bottom: 16px !important;
  }

  #social-button .vsc-popup-button:hover,
  #social-button .vsc-popup-button:focus {
    width: 158px !important;
  }

  #social-button .vsc-popup-button[aria-expanded="true"] {
    width: 118px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue